import { Popover } from "antd"
import { formatMoney } from "Helpers/helpFunction"

export default function NumberTrading({ data }: { data: any }) {
  const closePrice = data?.closePrice ? formatMoney(data?.closePrice, 2) : '--'
  const openPrice = data?.openPrice ? formatMoney(data?.openPrice, 2) : '--'
  const averageMatchVolume1Month = data?.averageMatchVolume1Month ? formatMoney(data?.averageMatchVolume1Month) : '--'
  const marcap = data?.marcap ? formatMoney((parseFloat(data?.marcap) / 1000000000).toFixed(0)) : '--'
  const outstandingShares = data?.outstandingShares ? formatMoney((parseFloat(data?.outstandingShares) / 1000000).toFixed(0)) : '--'
  const freeFloat = data?.freeFloat ? formatMoney((parseFloat(data?.freeFloat) / 1000000).toFixed(0)) : '--'

  return (
    <>
      <div className='LnlQJDZgDw'>
        {/* <div className='sRqFgiPXSm'>
          <div className='MelmxNfyJN'>Đóng cửa phiên trước</div>
          <div className='feUQoYfHgV rOdUvynwNB'>{closePrice}</div>
        </div>
        <div className='sRqFgiPXSm'>
          <div className='MelmxNfyJN'>Giá mở cửa</div>
          <div className='feUQoYfHgV zWgcpmNeDT'>{openPrice}</div>
        </div> */}
        <div className='sRqFgiPXSm'>
          <div className='MelmxNfyJN'>KL Giao dịch TB 1 tháng</div>
          <div className='feUQoYfHgV RiIjUzmqZf'>{averageMatchVolume1Month}</div>
        </div>
        <div className='sRqFgiPXSm'>
          <div className='MelmxNfyJN'>Vốn hoá <span className="lgiztqblvc">(Tỷ đồng)</span></div>
          <div className='feUQoYfHgV RiIjUzmqZf'>{marcap}</div>
        </div>
        <div className='sRqFgiPXSm'>
          <div className='MelmxNfyJN'>Số lượng lưu hành <span className="lgiztqblvc">(Triệu cp)</span></div>
          <div className='feUQoYfHgV RiIjUzmqZf'>{outstandingShares}</div>
        </div>
        <div className='sRqFgiPXSm'>
          <div className='MelmxNfyJN'>
            <Popover className="aykjfeixcj" placement="bottom" color="#ffffff" title={''} content={'Đang cập nhật'} trigger="hover">
              <div>Free float <span className="lgiztqblvc">(Triệu cp)</span></div>
            </Popover>
          </div>
          <div className='feUQoYfHgV RiIjUzmqZf'>{freeFloat}</div>
        </div>
      </div>
    </>
  )
}